import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import { AutoRechargeWidgetStore } from 'entities/Billing/ui/AutoRechargeModal'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export function showAutoRechargeRequired(
  entities: IEntitiesStore,
  {
    onSuccess,
    onFailed,
    useFor,
  }: {
    onSuccess?: () => void
    onFailed?: () => void
    useFor: string
  }
) {
  const { billingStore, subscriptionStore, usersStore } = entities
  const id = nanoid()

  const onClose = () => {
    onFailed?.()
    modalStore.removeModal(id)
  }

  const title = 'Auto-Recharge required'

  if (usersStore.user?.isAdminOrOwnerRole) {
    modalStore.addModal({
      id,
      type: ModalTypeList.INFO,
      title,
      desc: `To use ${useFor}, enable auto-recharge`,
      primaryAction: {
        onAction: async () => {
          modalStore.removeModal(id)
          new AutoRechargeWidgetStore(billingStore, subscriptionStore, {
            onSuccessEnable: onSuccess,
            onFailedEnable: onFailed,
          }).openModal()
        },
        text: 'Enable auto-recharge',
      },
      closeActionButtonProps: {
        text: 'Cancel',
        contained: 'secondary',
      },
      onClose,
    })
  } else {
    modalStore.addModal({
      id,
      type: ModalTypeList.INFO,
      title,
      desc: `To use ${useFor}, ask one of your admins to enable auto-recharge`,
      onClose,
    })
  }
}
